import { useReloadRegistry } from '../../../../hooks'

/**
 * Bundles the reload registries of every request-profile section that nested
 * components register into (see {@link useReloadRegistry}).
 */
export function useRequestProfileReloadRegistries() {
  const {
    handleReload: handleReloadOpenActivities,
    registerReload: registerOpenActivitiesReload,
  } = useReloadRegistry()

  const {
    handleReload: handleReloadRating,
    registerReload: registerRatingReload,
  } = useReloadRegistry()

  const {
    handleReload: handleReloadActivitiesTab,
    registerReload: registerActivitiesTabReload,
  } = useReloadRegistry()

  const {
    handleReload: handleReloadRelatedRequests,
    registerReload: registerRelatedRequestsReload,
  } = useReloadRegistry()

  const {
    handleReload: handleReloadDocFlowsTab,
    registerReload: registerDocFlowsTabReload,
  } = useReloadRegistry()

  const {
    handleReload: handleReloadDocumentsTab,
    registerReload: registerDocumentsTabReload,
  } = useReloadRegistry()

  const {
    handleReload: handleReloadEmailsTab,
    registerReload: registerEmailsTabReload,
  } = useReloadRegistry()

  const {
    handleReload: handleReloadPostsTab,
    registerReload: registerPostsTabReload,
  } = useReloadRegistry()

  return {
    handleReloadActivitiesTab,
    handleReloadDocFlowsTab,
    handleReloadDocumentsTab,
    handleReloadEmailsTab,
    handleReloadOpenActivities,
    handleReloadPostsTab,
    handleReloadRating,
    handleReloadRelatedRequests,
    registerActivitiesTabReload,
    registerDocFlowsTabReload,
    registerDocumentsTabReload,
    registerEmailsTabReload,
    registerOpenActivitiesReload,
    registerPostsTabReload,
    registerRatingReload,
    registerRelatedRequestsReload,
  }
}
